import { DeveloperSliceType } from 'src/core/models'

const myIntegrationState: DeveloperSliceType = {
  myIntegration: {
    loading: false,
    list: [],
    error: ''
  },
  myIntegrationHistory: {
    loading: false,
    data: []
  },
  userIntegrationsList: {
    loading: false,
    data: [],
    error: '',
    filtered: []
  },
  integrationPurchasesList: {
    loading: false,
    data: [],
    filtered: [],
    error: ''
  },
  integrationProjectsList: {
    loading: false,
    data: [],
    error: ''
  },
  createIntegration: {
    loading: false,
    success: false,
    error: null
  },
  mainChartData: {
    loading: false,
    sum_amount: 0,
    compensated_amount: 0,
    currency_symbol: '',
    data: []
  },
  integrationChartData: {
    loading: false,
    sum_amount: 0,
    compensated_amount: 0,
    currency_symbol: '',
    data: []
  },
  integrationStatics: {
    loading: false,
    data: {
      integration_code: '',
      integration_initials: '',
      sum_amount: 0,
      compensated_amount: 0,
      total_transactions: 0,
      integration_id: '',
      integration_type: 'PREPURCHASE',
      integration_token: '',
      integration_logo: null,
      currency_symbol: ''
    }
  },
  integrationWhiteLabel: {
    loading: false,
    whiteLabel: null
  },
  integrationsToShareProjectList: {
    loading: false,
    data: [],
    error: '',
    projectId: '',
    flag: false
  },
  deactivateIntegration: {
    loading: false,
    error: ''
  },
  reactivateIntegration: {
    loading: false,
    success: false,
    error: null
  },
  updateLogo: {
    loading: false,
    success: false,
  },
  offsetByExcel: {
    step: 0,
    keys: [],
    optionalFields: {
      use_company_name_in_offset: false,
      fields: []
    },
    offsetOptionalKeys: {
      year: null,
      km: null,
      impact1: null,
      impact2: null,
      drivers: null,
      users: null,
      trips: null,
      month: null,
      origin: null,
      destination: null,
    },
    excelData: [],
    offsetKeys: {
      identifierField: null,
      amountCo2Field: null,
      co2UnitField: null,
      emailField: null,
      nameField: null,
      lastNameField: null,
      companyNameField: null
    },
    preparePurchases: {
      loading: false,
      data: [],
      selectedProjectId: null,
      selectedVintageYear: 0
    },
    makePurchases: {
      loading: false,
      hasFinished: false,
      purchasesResults: [],
      failedPurchases: []
    }
  },
  allProjects: {
    loading: false,
    data: []
  },
  createDeposit: {
    loading: false,
    data: {
      deposit: null,
      merchant_parameters: {
        Ds_MerchantParameters: '',
        Ds_Signature: '',
        Ds_SignatureVersion: ''
      }
    },
    error: null
  },
  prePurchase: {
    loading: false,
    success: false,
    orderId: null,
    error: null
  },
  final_unit_price: {
    discount_amount: 0,
    sell_base_amount: 0,
    fee_amount: 0,
    fee_amount_percentage: 0,
    sell_vat: 0,
    sell_vat_percentage: 0,
    fee_vat: 0,
    fee_vat_percentage: 0,
    total_amount: 0,
    fixed_amount_transaction_fee: 0,
    partner_fee_percentage: 0,
    partner_fee_amount: 0,
    partner_fee_vat_amount: 0,
    supplier_discounts: {
      applied_discounts: [],
      applied_discounts_by_amount_type: [],
      supplier_discount: 0
    }
  },
}

export { myIntegrationState as initialState }
